module.exports = __webpack_public_path__ + "img/3(4)-340x378.5bbbed83.jpg";